import { render } from "./energy.vue?vue&type=template&id=22545763&scoped=true"
import script from "./energy.vue?vue&type=script&lang=js"
export * from "./energy.vue?vue&type=script&lang=js"

import "./energy.vue?vue&type=style&index=0&id=22545763&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-22545763"

export default script